import { css } from 'lit';

export const style = css`
  :host {
    display: block;
    margin: 0 1em 3em;
  }

  form {
    margin-bottom: 2em;
  }

  @media (min-width: 48em) {
    form {
      margin: 0 auto 2em;
      width: 30em;
    }
  }

  fs-text-field {
    margin-bottom: 1em;
  }

  section {
    margin-bottom: 3em;
    text-align: center;
  }

  section > ul {
    list-style-type: none;
    padding: 0;
  }

  section > ul > li {
    margin-bottom: 1.5em;
  }

  .mailing-instructions > h3 {
    font-size: 1.125em;
    font-weight: 600;
    margin-bottom: 0;
  }

  .mailing-instructions > p {
    margin: 0;
  }

  #submitButton {
    display: block;
    width: 100%;
  }

  @media (min-width: 48em) {
    #submitButton {
      margin-left: 40%;
      margin-right: 50%;
      width: 100px;
    }
  }
`;
